import LoginLayoutContainer from './containers/LoginLayoutContainer';

export default LoginLayoutContainer;
